export default __webpack_public_path__ + "static/media/GL Solo 5v5.fec7ab11.png";